import React, { useEffect, useState } from 'react'
import type { DroppableProps } from '@hello-pangea/dnd'
import { Droppable } from '@hello-pangea/dnd'

// as react beautiful dnd does not support we need to have it
// maybe move to https://www.npmjs.com/package/@hello-pangea/dnd in the future
export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false)
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true))
    return () => {
      cancelAnimationFrame(animation)
      setEnabled(false)
    }
  }, [])
  if (!enabled) {
    return null
  }
  return <Droppable {...props}>{children}</Droppable>
}

export default StrictModeDroppable
